export const LOGO_BLACK_URL = "/media/brand/walk-expeditions.webp";
export const LOGO_TRANSPARENT_URL = "/media/brand/walk-expeditions.webp";

export const HOME_HERO_JARDIN_PRIMARY_URL = "/media/home/hero-jardin-1.jpg";
export const HOME_HERO_JARDIN_SECONDARY_URL = "/media/home/hero-jardin-2.jpg";
export const HOME_HERO_PARRILLA_URL = "/media/home/hero-parrilla.jpg";
export const HOME_HERO_PISCINA_URL = "/media/home/hero-piscina.jpg";
export const PET_FRIENDLY_URL = "/media/home/petfriendly.jpg";
export const WORDS_IMAGE_URL = "/media/home/img-palabras.png";

export const PARTNER_LA_POZUCINA_URL = "/media/partners/la-pozucina.png";
export const PARTNER_POZUZO_BIER_URL = "/media/partners/pozuzo-bier.png";

export const ENTREPRENEURSHIP_IMAGE_URLS = [
  "/media/entrepreneurship/emprendimiento-principal.jpeg",
  "/media/entrepreneurship/cerveza.jpg",
  "/media/entrepreneurship/cerveza-2.jpg",
  "/media/entrepreneurship/emprendimiento-1.jfif",
  "/media/entrepreneurship/emprendimiento-2.jfif",
  "/media/entrepreneurship/pozucina.jpg",
] as const;

export const ABOUT_HISTORY_COVER_URL = "/media/about/foto-portada-1.jfif";
export const ABOUT_HERO_COVER_URL = "/media/about/foto-portada-3.jfif";
export const ABOUT_HUELLA_PRIMARY_URL = "/media/about/huella-ecologica-3.jfif";
export const ABOUT_HUELLA_SECONDARY_URL = "/media/about/huella-ecologica.jfif";
